import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';
import { NoCacheInterceptor } from '@auth/interceptors/no-cache.interceptor';
import { WithCredentialsInterceptor } from '@auth/interceptors/with-credentials.interceptor';
import {
  ApiPrefixInterceptor,
  ConcurrentIdenticalRequestInterceptor,
  HttpCacheInterceptor,
} from '@avenir-client-web/http';
import { ProgressBarInterceptor } from '@avenir-client-web/progress-bar';
import { ProgressSpinnerInterceptor } from '@avenir-client-web/progress-spinner';
import { SafePipe } from '@avenir-client-web/safe-pipe';
import { SanitizerPipe } from '@avenir-client-web/sanitizer';
import { ErrorHandlerInterceptor } from '@core/http/error-handler.interceptor';
import { PayloadHeaderInterceptor } from '@core/http/payload-header.interceptor';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

export function provideCore(): Provider[] {
  return [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProgressBarInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProgressSpinnerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiPrefixInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpCacheInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ConcurrentIdenticalRequestInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PayloadHeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WithCredentialsInterceptor,
      multi: true,
    },
    MessageService,
    DialogService,
    SanitizerPipe,
    SafePipe,
  ];
}
